import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
import { getAgeProgramHeaderImage } from "../../../adminApi/ageProgramHeaderApi";
import { ReactComponent as CloseIcon } from "../../../assets/images/icons/close-icon.svg";
const AddHeaderImage = ({ setShowHeaderImageModal, headerName }) => {
  const token = localStorage.getItem("access_token");
  const [selectedHeaderFile, setSelectedHeaderFile] = useState();
  const [images, setImages] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [headerImage, setHeaderImage] = useState();
  const [description, setDescription] = useState();
  useEffect(() => {
    getHeaderImages();
  }, []);

  const getHeaderImages = async () => {
    try {
      const response = await getAgeProgramHeaderImage(token);
      if (headerName === "Browse by Program") {
        setHeaderImage(response?.data?.data?.[0]?.browse_by_program_header);
        setDescription(response?.data?.data?.[0]?.browse_by_program_desc);
      } else {
        setHeaderImage(response?.data?.data?.[0]?.browse_by_age_header);
        setDescription(response?.data?.data?.[0]?.browse_by_age_desc);
      }
    } catch (error) {
      return error;
    }
  };
  const handleFileChange2 = async (e) => {
    e.preventDefault();
    if (
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "jpeg" ||
      e.target.value?.split(".")?.[1]?.toLowerCase() === "png"
    ) {
      try {
        const selectedFiles = e.target.files;
        if (selectedFiles && selectedFiles?.length > 0) {
          const file = selectedFiles[0];
          setSelectedHeaderFile(file?.name);
          const reader = new FileReader();

          // Create a Promise to wait for the FileReader to load
          const loadPromise = new Promise((resolve) => {
            reader.onloadend = () => {
              resolve();
            };
          });

          // Start loading the file
          reader.readAsDataURL(file);

          // Wait for the FileReader to finish loading
          await loadPromise;

          const img = new Image();
          img.src = reader.result;

          img.onload = async () => {
            // Set the desired height and width
            const desiredHeight = 780;
            const desiredWidth = 1920;

            // Create a canvas element to draw the image with the new dimensions
            const canvas = document.createElement("canvas");
            canvas.height = desiredHeight;
            canvas.width = desiredWidth;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            // Convert the canvas content to a data URL
            const convertedFile = {
              image: canvas.toDataURL("image/jpeg"), // Use 'image/jpeg' for JPEG format
            };

            const convertedFileName = {
              name: file.name,
            };
            setImages([convertedFile]);
          };
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      toast.error(
        `Invalid format of image, image should only be JPEG,PNG and JPG`
      );
      return;
    }
  };
  const headerImageHandler = async () => {
    let data;
    if (images?.[0]?.image === undefined || images?.[0]?.image === null) {
      data = {
        id: 1,
        [headerName === "Browse by Program" ? "desc_program" : "desc_age"]:
          description,
      };
    } else if (images?.[0]?.image && description) {
      data = {
        id: 1,
        [headerName === "Browse by Program" ? "desc_program" : "desc_age"]:
          description,
        [headerName === "Browse by Program" ? "image" : "image2"]:
          images?.[0]?.image,
      };
    }
    try {
      setShowLoader(true);
      const response = await axios.put(
        process.env.REACT_APP_BASE_URL + `/admin/update_header`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status === 200 || response?.status === 201) {
        toast.success("Header image updated successfully.");
        setShowLoader(false);
        setShowHeaderImageModal(false);
      }
    } catch (error) {}
  };
  return (
    <>
      <div
        className="Admin-modal Admin-modal--open"
        id="modalCategory"
        role="dialog"
      >
        <div className="Admin-modal__dialog Admin-modal__dialog--sm">
          <div className="Admin-modal__content" style={{ width: "150%" }}>
            <div className="Admin-modal__head">
              <h2 className="Admin-modal__head--title">{headerName}</h2>
              <button
                className="Admin-modal__close"
                onClick={() => setShowHeaderImageModal(false)}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="Admin-modal__body">
              <div className="input_formGroup"></div>
              <div class="accordion__card__body" style={{ display: "block" }}>
                <div class="commonList">
                  {showLoader ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <FadeLoader color="#5497C7" height={25} width={9} />
                    </div>
                  ) : (
                    <div class="commonList__row">
                      <div class="commonList__row__col">
                        <h4 class="label" style={{ color: "black" }}>
                          Header Image:
                        </h4>
                        <div class="cardbox">
                          <div class="browseBox">
                            <div class="browseFile">
                              <div class="browseFile__icon">
                                <svg
                                  width="33"
                                  height="33"
                                  viewBox="0 0 33 33"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                >
                                  <rect
                                    x="0.180664"
                                    width="32.53"
                                    height="32.53"
                                    fill="url(#pattern0)"
                                  />
                                  <defs>
                                    <pattern
                                      id="pattern0"
                                      patternContentUnits="objectBoundingBox"
                                      width="1"
                                      height="1"
                                    >
                                      <image xlinkHref="data:image/png;base64,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" />
                                    </pattern>
                                  </defs>
                                </svg>
                              </div>
                              <h4 class="browseFile__text">
                                Drag files to upload
                              </h4>
                              <p class="browseFile__ortext">or</p>
                              <input
                                class="hiddenInput"
                                id="BrowseFiles"
                                type="file"
                                onChange={(e) => handleFileChange2(e)}
                              />
                              <label for="BrowseFiles" class="browseBtn">
                                Browse Files
                              </label>
                              <h6 className="programSelectedFile">
                                {selectedHeaderFile}
                              </h6>
                              <div class="browseFileData">
                                <p class="browseFileData__text">
                                  Max File Size: <strong>10 MB</strong>
                                </p>
                                <p class="browseFileData__text">
                                  Supported file type:{" "}
                                  <strong>JPG,PNG,SVG</strong>
                                </p>
                              </div>

                              <div style={{ border: "0.2px solid #f2f2f2" }}>
                                <img
                                  src={headerImage}
                                  alt="header-image-preview"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="commonList__row__col">
                        <h4 class="label" style={{ color: "black" }}>
                          Description:
                        </h4>
                        <textarea
                          cols={200}
                          className="adminform__textarea"
                          placeholder="Enter the description."
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  )}
                  <button
                    className="btn adminbtn-primary"
                    onClick={() => headerImageHandler()}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddHeaderImage;
